import { gql } from 'graphql-request';

export const GET_SOCIAL_PROOF_MARKET_ACTIVITY = gql`
  query SocialProofMarketActivity(
    $availableJobsInput: JobQueryInput
    $marketIds: [Int!]
    $positionIds: [Int!]
  ) {
    socialProofMarketActivity {
      shifts_count(market_ids: $marketIds, position_ids: $positionIds)
      min_pay_amount_cents(market_ids: $marketIds, position_ids: $positionIds)
      max_pay_amount_cents(market_ids: $marketIds, position_ids: $positionIds)
    }
    _availableJobsMeta(input: $availableJobsInput) {
      count
    }
  }
`;
